import {
  SUCCESS_REGISTRATION,
  ERROR_REGISTRATION,
  AUTHENTICATED_USER,
  SUCCESS_LOGIN,
  ERROR_LOGIN,
  CLOSE_SESION,
  CHANGE_PASSWORD_OK,
  TELL_A_FRIEND_OK,
  REGENERATE_UNAUTHORIZED_DOCUMENTS,
  GET_PENDING_DOCUMENTS,
  ASK_FOR_ANEW_SERVICE_OK,
  RECEIVE_NEW_VOUCHER_TO_PROCESS_OK,
  SUCCESS_FORGOT_PASSWORD,
  ERROR_FORGOT_PASSWORD,
  SET_AUTH,
  GET_THE_NEWS_RESPONSE
} from "../../types";

export default (state, action) => {
  switch (action.type) {
    case SUCCESS_REGISTRATION:
    case SUCCESS_LOGIN:
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("user", action.payload.user.name);
      localStorage.setItem("authenticated", true);
      localStorage.setItem("hasToChange", action.payload.hasToChangePassword);
      localStorage.setItem("hasIntegrationsRole", action.payload.hasIntegrationsRole);
      if(action.payload.customers){
          localStorage.setItem("customers", JSON.stringify(action.payload.customers));
      }
      return {
        ...state,
        authenticated: true,
        message: null,
        loading: false,
        hasToChange: action.payload.hasToChangePassword,
        hasIntegrationsRole: action.payload.hasIntegrationsRole,
        user: action.payload.user.name,
        showLoginExpiredMessage: false,
        customers:action.payload.customers??null
      };
    case AUTHENTICATED_USER:
      return {
        ...state,
        showLoginExpiredMessage: false,
        authenticated: true,
        loading: false,
        user: localStorage.getItem("user"),
      };

    case SUCCESS_FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordOk: true,
      };

    case ERROR_FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordOk: false,
      };

    case CLOSE_SESION:

    case ERROR_LOGIN:
    case ERROR_REGISTRATION:
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("authenticated", null);
      localStorage.removeItem("hasToChange", false);
      return {
        ...state,
        token: null,
        user: null,
        authenticated: null,
        message: action.payload,
        loading: false,
        showLoginExpiredMessage: false
      };
    case CHANGE_PASSWORD_OK:
      return {
        ...state,
        authenticated: true,
        /* message: "La contraseña ha sido cambiada", */
        loading: false,
        hasToChange: false,
      };
    case TELL_A_FRIEND_OK:
      return {
        ...state,
        authenticated: true,
        /* message: "La contraseña ha sido cambiada", */
        loading: false,
        hasToChange: false,
      };
    case REGENERATE_UNAUTHORIZED_DOCUMENTS:
      return {
        ...state,
        authenticated: true,
        /* message: "La contraseña ha sido cambiada", */
        loading: false,
        hasToChange: false,
      };
    case GET_PENDING_DOCUMENTS:
      return {
        ...state,
        authenticated: true,
        data: action.payload,
        sessionExpired: false,
        loading: false,
      };
    case ASK_FOR_ANEW_SERVICE_OK:
      return {
        ...state,
        authenticated: true,
        /* message: "La contraseña ha sido cambiada", */
        loading: false,
        hasToChange: false,
      };
    case RECEIVE_NEW_VOUCHER_TO_PROCESS_OK:
      return {
        ...state,
        authenticated: true,
        loading: false,
        hasToChange: false,
      };
    case SET_AUTH:
      return {
        ...state,
        /* authenticated: false, */
        token: null,
        user: null,
        authenticated: null,
        showLoginExpiredMessage: true,
        loading: false,
      };
      case GET_THE_NEWS_RESPONSE:
        return {
          ...state,
          news:action.payload.data.data.news
        };
     
    default:
      return state;
  }
};
